(() => {
  const tokenPattern = /^v1\.[a-f0-9]{32}\.\d{10}\.[a-f0-9]{64}$/;
  const storageKey = 'glamp_ai_ref';
  const syncKey = 'glamp_ai_cart_ref_synced';

  const readCookie = (name) => {
    const prefix = `${name}=`;
    const item = document.cookie.split('; ').find((value) => value.startsWith(prefix));
    return item ? decodeURIComponent(item.slice(prefix.length)) : '';
  };

  const params = new URLSearchParams(window.location.search);
  const queryToken = params.get(storageKey) || '';
  const storedToken = window.localStorage.getItem(storageKey) || readCookie(storageKey);
  const token = tokenPattern.test(queryToken) ? queryToken : (tokenPattern.test(storedToken) ? storedToken : '');
  if (!token) return;

  window.localStorage.setItem(storageKey, token);
  document.cookie = `${storageKey}=${encodeURIComponent(token)}; Max-Age=2592000; Path=/; Domain=.glamp.tokyo.jp; SameSite=Lax; Secure`;

  if (queryToken) {
    params.delete(storageKey);
    const cleanQuery = params.toString();
    const cleanUrl = `${window.location.pathname}${cleanQuery ? `?${cleanQuery}` : ''}${window.location.hash}`;
    window.history.replaceState({}, document.title, cleanUrl);
  }

  if (window.sessionStorage.getItem(syncKey) === token) return;

  fetch(window.routes?.cart_update_url || '/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ attributes: { glamp_ai_ref: token } }),
  })
    .then((response) => {
      if (!response.ok) throw new Error('cart_attribute_sync_failed');
      window.sessionStorage.setItem(syncKey, token);
    })
    .catch(() => {});
})();

